//BigCommerce Payments grouped payment methods
export const BIGCOMMERCE_PAYMENTS = 'bigcommerce_payments';
export const BIGCOMMERCE_PAYMENTS_PAYLATER = 'bigcommerce_payments_paylater';
export const BIGCOMMERCE_PAYMENTS_CREDIT_CARDS = 'bigcommerce_payments_creditcards';
export const BIGCOMMERCE_PAYMENTS_FASTLANE = 'bigcommerce_payments_fastlane';
export const BIGCOMMERCE_PAYMENTS_APMS = 'bigcommerce_payments_apms';
export const BIGCOMMERCE_PAYMENTS_VENMO = 'bigcommerce_payments_venmo';
export const BIGCOMMERCE_PAYMENTS_INVOICES = 'bigcommerce_payments_invoices';

//Braintree grouped payment methods
export const BRAINTREE = 'braintree';
export const BRAINTREE_PAYPAL = 'braintreepaypal';
export const BRAINTREE_PAYPAL_CREDIT = 'braintreepaypalcredit';
export const BRAINTREE_VISACHECKOUT = 'braintreevisacheckout';
export const BRAINTREE_LOCAL_METHODS = 'braintreelocalmethods';
export const BRAINTREE_GOOGLEPAY = 'googlepaybraintree';
export const BRAINTREE_ACH = 'braintreeach';
export const BRAINTREE_ACCELERATED_CHECKOUT = 'braintreeacceleratedcheckout';

//Paypal Commerce grouped payment methods
export const PAYPAL_COMMERCE = 'paypalcommerce';
export const PAYPAL_COMMERCE_ACCELERATED_CHECKOUT = 'paypalcommerceacceleratedcheckout';
export const PAYPAL_COMMERCE_ALTERNATIVE_METHODS = 'paypalcommercealternativemethods';
export const PAYPAL_COMMERCE_CREDIT = 'paypalcommercecredit';
export const PAYPAL_COMMERCE_CREDIT_CARDS = 'paypalcommercecreditcards';
export const PAYPAL_COMMERCE_VENMO = 'paypalcommercevenmo';
